import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { NgForm, FormsModule } from "@angular/forms";
import { ResourceRuleStore } from "@app/services/store/resource-rule-store";
import { ResourceModel } from "@app/models/rest/resource";
import { RuleType } from "@app/models/enums/resource-rule-type";
import { PropertyService } from "@app/integrations/urm/services/property.service";
import { ClientConfigService } from "@app/core/config/client-config.service";
import { PropPropertyHeader } from "@app/integrations/urm/models/prop-property-header";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import { MatIconAnchor, MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { PropertySearchComponent } from "../../../../../integrations/urm/views/property-search/property-search.component";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "scheduler-resource-rule-add",
  templateUrl: "./resource-rule-add.component.html",
  styleUrls: ["./resource-rule-add.component.css"],
  imports: [
    MatToolbar,
    MatToolbarRow,
    MatIconAnchor,
    MatDialogClose,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    PropertySearchComponent,
    FormsModule,
    MatFormField,
    MatInput,
    MatDialogActions,
    MatButton,
    TranslatePipe
  ]
})
export class ResourceRuleAddComponent {
  resourceRuleStore = inject(ResourceRuleStore);
  corePropertyService = inject(PropertyService);
  clientConfig = inject(ClientConfigService);
  dialogRef = inject<MatDialogRef<ResourceRuleAddComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  resource: ResourceModel;
  ruleValue: string = ""; // Default value for ruleValue
  isSearchMode: boolean = false;

  constructor() {
    const clientConfig = this.clientConfig;
    const data = this.data;

    this.resource = data.resource;
    this.isSearchMode = clientConfig.config.urmServices.enabled;
  }

  async onSelectClick(form: NgForm) {
    if (form.valid) {
      console.log("select");
      this.resourceRuleStore
        .create({
          resource: this.resource,
          ruleType: RuleType.PROPERTY_EXCLUSION,
          ruleValue: this.ruleValue
        } as any)
        .subscribe(() => {
          this.dialogRef.close();
        });
    }
  }

  async onCancelClick() {
    this.dialogRef.close();
  }

  onPropertySelected($event: PropPropertyHeader) {
    console.log("Property selected", $event);
    this.resourceRuleStore
      .create({
        resource: this.resource,
        ruleType: RuleType.PROPERTY_EXCLUSION,
        ruleValue: $event.Proh_PropertyId.trimEnd()
      } as any)
      .subscribe(() => {
        this.dialogRef.close();
      });
  }
}
